import { AxiosResponse } from "axios";
import { endPoints } from "utils/constants";
import { crudService } from "services/crud.service";
import {
  defaultMetaObj,
  initialCompanyState,
  initialContactState,
} from "store/constants";
import { PayloadAction, createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const { companyEndPoint } = endPoints;

export const fetchCompanyData = createAsyncThunk(
  "company/fetchCompanyData",
  async ({ companyId }: { companyId: string }, { rejectWithValue }) => {
    try {
      const response: AxiosResponse = await crudService.getAll(
        `${companyEndPoint}/${companyId}`,
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

const companySlice = createSlice({
  name: "company",
  initialState: initialCompanyState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch all tasks
    builder
      .addCase(fetchCompanyData.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        fetchCompanyData.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.company = action.payload;
          state.meta = action.payload?.meta || {};
        },
      )
      .addCase(
        fetchCompanyData.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
          state.meta = defaultMetaObj;
        },
      );
  },
});

export const companyReducer = companySlice.reducer;
